import React from 'react';
import Hero from '../components/home/Hero';
import CategoryGrid from '../components/home/CategoryGrid';
import ProductReel from '../components/home/ProductReel';
import Inspiration from '../components/home/Inspiration';
import { Truck, ShieldCheck, Sprout } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <Hero />
      
      {/* USPs */}
      <section className="bg-primary text-primary-foreground py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors cursor-default">
              <div className="p-3 bg-white/10 rounded-full shrink-0">
                <Truck className="h-8 w-8 text-accent" />
              </div>
              <div>
                <h3 className="font-bold text-lg mb-1">Frakt til hele Norge</h3>
                <p className="text-primary-foreground/70 text-sm">Rask og sikker levering til hele landet. Bestill enkelt på nett.</p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row items-center md:items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors cursor-default">
               <div className="p-3 bg-white/10 rounded-full shrink-0">
                <ShieldCheck className="h-8 w-8 text-accent" />
              </div>
              <div>
                <h3 className="font-bold text-lg mb-1">Kvalitetsgaranti</h3>
                <p className="text-primary-foreground/70 text-sm">Alle frø er nøye utvalgt for norske klimaforhold og høy spireevne.</p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center md:items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors cursor-default">
               <div className="p-3 bg-white/10 rounded-full shrink-0">
                <Sprout className="h-8 w-8 text-accent" />
              </div>
              <div>
                <h3 className="font-bold text-lg mb-1">Fagkunnskap</h3>
                <p className="text-primary-foreground/70 text-sm">Spør oss om råd. Vi har lang erfaring med frødyrking og hageglede.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CategoryGrid />
      
        <ProductReel 
        title="Ukens Utvalgte" 
        subtitle="Frø og produkter vi anbefaler akkurat nå."
        featured={true}
      />

      {/* Campaign Banner */}
      <section className="py-20 container mx-auto px-4">
         <div className="relative rounded-3xl overflow-hidden bg-primary h-[400px] flex items-center shadow-2xl group cursor-pointer">
            <div className="absolute inset-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/mk89xwnm_image.png" 
                  alt="Garden" 
                  className="w-full h-full object-cover opacity-30 mix-blend-overlay transition-transform duration-1000 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/80 to-transparent" />
            </div>
            
            <div className="relative z-10 max-w-2xl px-8 md:px-16 animate-fade-in-up">
                <span className="text-accent font-bold tracking-widest uppercase mb-4 block">Vårens beste</span>
                <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">
                  Så i gang – det er vårens tid!
                </h2>
                <p className="text-xl text-primary-foreground/90 mb-8 max-w-lg leading-relaxed">
                  Utforsk 469 frøsorter av blomster, grønnsaker og urter. Alt nøye utvalgt for norske klimaforhold.
                </p>
                <Link to="/category/blomster">
                  <Button className="bg-white text-primary hover:bg-accent hover:text-white font-bold py-6 px-8 rounded-full transition-all shadow-lg text-lg hover:shadow-xl hover:-translate-y-1">
                    Se utvalget
                  </Button>
                </Link>
            </div>
         </div>
      </section>

      <Inspiration />
    </>
  );
};

export default Home;
